import React from "react";
import "./SubFooter.css"


export default function SubFooter () {

    return(
        <div className="sub-footer">
            <p>Website created by DWD</p>
        </div>
        
    
    )
}